<div class="mb-3 col-md-1 ml-md-auto">
    <button routerLink="/materialMix" class="btn btn-outline-danger btn-sm" role="button" aria-pressed="true">View Mix Material</button>
</div>

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">

                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-10">
                                    <h4 class="text-center font-bold font-up danger-text">Allocated Materials List for Allotting Process</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table mb-0 table-centered table-bordered">
                            <thead>
                              <tr>
                                <th (click)="onSortColumn('_id')">Order Id 
                                  <i class="feather icon-arrow-up" *ngIf="sortColumn === '_id' && sortDirection === 'asc'"></i>
                                  <i class="feather icon-arrow-down" *ngIf="sortColumn === '_id' && sortDirection === 'desc'"></i>
                                </th>
                                <th (click)="onSortColumn('materialProcesses')">Material Mix
                                  <i class="feather icon-arrow-up" *ngIf="sortColumn === 'materialProcesses' && sortDirection === 'asc'"></i>
                                  <i class="feather icon-arrow-down" *ngIf="sortColumn === 'materialProcesses' && sortDirection === 'desc'"></i>
                                </th>
                                <th class="text-end">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of displayedList">
                                <td>{{ item._id }}</td>
                                <td>
                                  <div class="material-processes-container">
                                    <div *ngFor="let mat of item.materialProcesses" class="material-process">
                                      <div class="material-detail">
                                        <strong>Process Id:</strong> {{ mat.processId }}
                                      </div>
                                      <div class="material-detail">
                                        <strong>Material:</strong> {{ mat.material }}
                                      </div>
                                      <div class="material-detail">
                                        <strong>Process:</strong> {{ mat.process }}
                                      </div>
                                      <hr class="separator" />
                                    </div>
                                  </div>
                                </td>
                                <td class="text-end">
                                  <button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteRow(item._id)" title="Delete Process">
                                    <i class="feather icon-trash-2"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                    </div>

                    <!-- Pagination Controls -->
                    <div class="datatable-footer-inner d-flex justify-content-between mt-3">
                        <div class="page-count">
                            <span class="font-weight-bold">{{ displayedList.length }} of {{ totalItems }} total</span>
                        </div>
                        <div class="pagination">
                            <a class="pagination-btn" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                                <i class="feather icon-chevrons-left"></i>
                            </a>
                            <a *ngFor="let page of getPages()" class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">
                                {{ page }}
                            </a>
                            <a class="pagination-btn" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === getPages().length}">
                                <i class="feather icon-chevrons-right"></i>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
